import { render, staticRenderFns } from "./search-card.vue?vue&type=template&id=22ac26e0&scoped=true"
import script from "./search-card.vue?vue&type=script&lang=js"
export * from "./search-card.vue?vue&type=script&lang=js"
import style0 from "./search-card.vue?vue&type=style&index=0&id=22ac26e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ac26e0",
  null
  
)

export default component.exports